"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DocumentationLink = function (_a) {
    var url = _a.url;
    return (react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-section gd-measure-custom-format-dialog-section-help" },
        react_1.default.createElement("a", { className: "gd-measure-format-button s-custom-format-dialog-documentation-link", target: "_blank", rel: "noreferrer noopener", href: url },
            react_1.default.createElement("div", { className: "gd-icon-circle-question gd-measure-format-button-icon-left" }),
            react_1.default.createElement("span", null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "measureNumberCustomFormatDialog.howToFormat" })))));
};
exports.default = react_intl_1.injectIntl(DocumentationLink);
//# sourceMappingURL=DocumentationLink.js.map